(function(){
'use strict';

angular.module('classy.frs', []);
angular.module('classy.frs.donation', ['classy', 'classy.frs']);
})();